import { enableProdMode, importProvidersFrom } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
//import { AppModule } from './app/app.module'; // only if still using NgModule
import { provideHttpClient, withFetch, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { environment } from './environments/environment';
import { ErrorHandler } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app/app.routes'
import { BaseUrlInterceptor } from './app/Interceptor/BaseUrlInterceptor'
import { numberInterceptor } from './app/Interceptor/numberInterceptor'
import { dateInterceptor } from './app/Interceptor/dateInterceptor'
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { Session_ErrorHandler } from './app/Interceptor/SessionErrorHandler';

if (environment.production) {
  enableProdMode();

  //Remove logging from prodution
  const methods: (keyof Console)[] = ["log", "debug", "warn", "info"];
  methods.forEach(method => {
    console[method] = () => { /* no-op */ };
  });
}

bootstrapApplication(AppComponent, {
  providers: [
    provideHttpClient(
      withFetch(),
      withInterceptors([
        BaseUrlInterceptor, // ONLY if this is a function too
        numberInterceptor,
        dateInterceptor
      ])
    ),
    provideRouter(routes),
    { provide: ErrorHandler, useClass: Session_ErrorHandler }
  ],
});

/*
bootstrapApplication(AppComponent, {
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    provideRouter(routes),
    provideAnimations(), 
    { provide: HTTP_INTERCEPTORS, useClass: BaseUrlInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: numberInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: dateInterceptor, multi: true },
    //{ provide: ErrorHandler, useClass: Session_ErrorHandler },
  ],
});
*/
